module.exports = __webpack_public_path__ + "static/CGU_2022-29b71b543b278bfd3cb23b56d6f11562.pdf";